module.exports = __webpack_public_path__ + "static/media/arrow-alt-down.5613a592.svg";